export default __webpack_public_path__ + "static/media/Icon-Projects-White.8b52fd3d.svg";